<template>
  <request-form mode="Accepted">
    <p>
      発行依頼に必要な手続きがすべて完了しました。<br>
      ご登録のメールアドレス宛にメールを送信しましたので、ご確認ください。
    </p>
    <text-browse-item label="発行依頼ID" :value="id" />
    <text-browse-item label="依頼物件名・棟名" :value="building.name" />
    <text-browse-item label="依頼物件名・棟名（カナ）" :value="building.name_kana" />
    <text-browse-item label="依頼物件住戸番号" :value="buildingHouseNumber" />
    <text-browse-item label="所有者" :value="owner_name" />
    <text-browse-item label="依頼物件郵便番号" :value="building.postal_code" />
    <text-browse-item label="依頼物件住所" :value="building.address" />
    <text-browse-item label="発行書類" :value="issueDocumentName" />
    <text-browse-item label="手数料の支払方法" :value="paymentMethodName" />
    <text-browse-with-unit-item label="請求金額" :value="billing_price" unit="円" />
    <text-browse-with-unit-item label="発行所要日数" :value="days_to_issue" unit="営業日" />
    <textarea-browse-item v-if="canShowBankInfo" label="銀行情報" :value="accountBank" />
    <textarea-browse-item v-if="canShowBankInfo" label="口座情報" :value="accountInfo" />
    <textarea-browse-item v-if="canShowBankInfo" label="口座名義" :value="accountFolder" />
    <text-browse-item v-if="isOwner" label="依頼者住所" :value="owner_address" />
    <textarea-browse-item label="備考" :value="note" />
    <text-browse-item label="振込日" :value="transfer_date" />
    <template #expansion-buttons-center v-if="!isGuest">
      <router-button text="引き続き発行依頼を行う" :to="{name: 'IssuanceRequestRegister'}" />
      <router-button text="TOPに戻る" :to="{name: 'Top'}" />
    </template>
  </request-form>
</template>

<script>
import {mapMutations, mapState, mapGetters} from "vuex";
import {convertPaymentMethodToName} from '@/constants/payment_method';
import RequestForm from '@/views/templates/forms/RequestForm';
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import TextBrowseWithUnitItem from '@/views/molecules/browseItems/TextBrowseWithUnitItem';
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import RouterButton from '@/views/molecules/buttons/RouterButton';
import bankAccountTypeOptions from '@/constants/bank_account_type_options';

export default {
  name: 'IssuanceRequestComplete',
  components: {
    RequestForm,
    TextBrowseItem,
    TextBrowseWithUnitItem,
    TextareaBrowseItem,
    RouterButton,
  },
  inject: [
    '$constant'
  ],
  computed: {
    ...mapState('issuance_request_form', {
      id: state => state.data.id ? state.data.id.toString() : null,
      buildingHouseNumber: state => state.data.building_house_number,
      owner_name: state => state.data.owner_name,
      building: state => state.data.building,
      billing_price: state => state.data.billing_price,
      note: state => state.data.note,
      payment_method_code: state => state.data.payment_method,
      transfer_date: state=> state.data.transfer_date,
      owner_address: state => state.data.requester.address,
      days_to_issue: state => state.data.building.management_company.days_to_issue,
      transfer_information: state => state.data.transfer_information,
      management_association_bank: state => state.data.management_association_bank,
      bank_multiple: state => state.data.building.management_company.bank_multiple,
      main_bank: state => state.data.building.management_company.main_bank,
    }),
    ...mapState('account', {
      isGuest: state => state.is_guest,
      guestType: state => state.guest_type,
    }),
    ...mapGetters('issuance_request_form', [
      'issueDocumentName',
    ]),
    paymentMethodName() {
      return convertPaymentMethodToName(this.payment_method_code);
    },
    isOwner() {
      return this.guestType === this.$constant.GUEST_TYPE.OWNER.code;
    },
    transferInfoFromBankObject() {
      const bank = this.bank_multiple
        ? (this.management_association_bank || this.main_bank || null)
        : this.main_bank;
      if (!bank) return null;

      const typeText = bankAccountTypeOptions.list
        .find(t => t.value === bank.bank_account_type)?.text ?? '';

      return [
        bank.bank_name ?? '',
        bank.bank_branch_name ?? '',
        typeText,
        bank.bank_account_no ?? '',
        bank.bank_account_name ?? '',
        bank.bank_account_name_kana ?? '',
      ];
    },
    displayTransferInformation() {
      if (Array.isArray(this.transfer_information) && this.transfer_information.length) {
        return this.transfer_information;
      }

      const fallback = this.transferInfoFromBankObject;
      return fallback?.length ? fallback : [];
    },
    canShowBankInfo() {
      return this.billing_price !== 0
        && this.payment_method_code === this.$constant.PAYMENT_METHOD_CODE.PREPAID.code
        && this.displayTransferInformation.length > 0;
    },
    accountBank() {
      return this.displayTransferInformation
        ? this.displayTransferInformation.slice(0, 2).join('　')
        : '';
    },
    accountInfo() {
      return this.displayTransferInformation
        ? this.displayTransferInformation.slice(2, 4).join('　')
        : '';
    },
    accountFolder() {
      return this.displayTransferInformation
        ? this.displayTransferInformation.slice(4, 6).join('　')
        : '';
    },
  },
  beforeRouteLeave() {
    this.resetData();
    this.clearUploadTransferStatement();
  },
  methods: {
    ...mapMutations('issuance_request_form', [
      'clearUploadTransferStatement',
      'resetData'
    ]),
  }
}
</script>
